import React from 'react';
import styled from 'styled-components';
import { track } from '../../analytics/utils';
import {
  FacebookIcon,
  InstagramIcon,
  PinterestIcon,
  YoutubeIcon,
} from '../../components';

export const SocialNetworkIcons = () => {
  return (
    <>
      <InstagramIcon
        onClick={() => {
          track('Footer Clicked', {
            link_cta: 'instagram',
          });
          window.open('https://instagram.com/glossier');
        }}
      />
      <FacebookIcon
        onClick={() => {
          track('Footer Clicked', {
            link_cta: 'facebook',
          });
          window.open('https://www.facebook.com/glossier');
        }}
      />
      <PinterestIcon
        onClick={() => {
          track('Footer Clicked', {
            link_cta: 'pinterest',
          });
          window.open('https://www.pinterest.com/glossiernyc/');
        }}
      />
      <YoutubeIcon
        onClick={() => {
          track('Footer Clicked', {
            link_cta: 'youtube',
          });
          window.open('https://www.youtube.com/c/Glossier');
        }}
      />
    </>
  );
};

export const legalLinks = [
  {
    description: 'Privacy Policy',
    link: 'https://www.glossier.com/privacy-policy',
    trackingDescription: {
      link_cta: 'Privacy Policy',
    },
  },
  {
    description: 'Terms of Use',
    link: 'https://www.glossier.com/terms-of-use',
    trackingDescription: {
      link_cta: 'Terms of Use',
    },
  },
  {
    description: 'Accessibility',
    link: 'https://www.glossier.com/website-accessibility-statement',
    trackingDescription: {
      link_cta: 'Website Accessibility Statement',
    },
  },
  {
    description: 'Supply Chain Transparency',
    link: 'https://www.glossier.com/supply-chain-transparency',
    trackingDescription: {
      link_cta: 'Supply Chain Transparency',
    },
  },
  {
    description: 'Your Privacy Choices',
    link: 'https://www.glossier.com/pages/privacy-preference-center',
    trackingDescription: {
      link_cta: 'Your Privacy Choices',
    },
    isPrivacyLink: true,
  },
];

export const footerLinks = {
  about: {
    text: 'About us',
    href: 'https://www.glossier.com/about',
    tracking: 'About',
  },
  contact: {
    text: 'Contact',
    href: 'https://help.glossier.com',
    tracking: 'Contact',
  },
  returns: {
    text: 'Return & Exchanges',
    href: 'https://www.glossier.com/help#returns',
    tracking: 'Return & Exchanges',
  },
  help: {
    text: 'Help & FAQ',
    href: 'https://www.glossier.com/help',
    tracking: 'Help & FAQ',
  },
  itg: {
    text: 'Into the Gloss',
    href: 'https://intothegloss.com/',
    tracking: 'Into the Gloss',
  },
};

export const FooterLinkWrapper = styled.div`
  width: 100%;
  text-align: left;
  margin-top: 12px;
  a {
    color: white;
    text-decoration: none;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    &:hover {
      text-decoration: underline;
      transition: 0.15s linear;
      opacity: 0.5;
    }
  }
`;

export const LegalLink = styled.a`
  color: #757676;
  font-size: 12px;
  line-height: 16px;
  text-decoration: underline;
  display: flex;
  align-items: center;
  &:hover {
    transition: 0.15s linear;
    opacity: 0.5;
  }
  img {
    margin-left: 4px;
  }
`;
